import gql from 'graphql-tag';

export const IntlLoyaltyAssignPersonalizedOffer = gql`
  mutation ctgLoyaltyCreatePersonalizedOffer(
    $loyaltyId: String!
    $offerTemplateId: String!
    $offerConfigId: String!
    $cognitoId: String!
    $reason: String!
    $offerName: String
    $orderId: String
    $comments: String
  ) {
    ctgLoyaltyCreatePersonalizedOffer(
      loyaltyId: $loyaltyId
      offerTemplateId: $offerTemplateId
      offerConfigId: $offerConfigId
      cognitoId: $cognitoId
      reason: $reason
      offerName: $offerName
      orderId: $orderId
      comments: $comments
    ) {
      configId
      id
      loyaltyId
      offerTemplateId: sourceId
    }
  }
`;
